import React, { useEffect, useRef, useState } from "react";

export const AutoCompleteV2 = ({
    listaOpciones = [],
    cambiarOpcionSeleccionada
}) => {
    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white"   
    const [muestraOpciones,setMuestraOpciones] = useState(false)
    const [textoInput,setTextoInput] = useState('')
    const [opcionSeleccionada,setOpcionSeleccionada] = useState(0)

    return(
        <div className="w-full relative">
            <input 
                placeholder="(Busqueda)"
                value={textoInput}
                onChange={e => setTextoInput(e.target.value)}
                onFocus={() => setMuestraOpciones(true)} 
                onBlur={() => {
                    setTimeout(() => {
                        setMuestraOpciones(false)
                    }, 200);
                }} 
                className={classNameInput} 
                type="text"
            />
            <div className={`${muestraOpciones ? '' : 'hidden'} absolute border border-[#767676] bg-[#27272a] z-[100000000] w-full max-h-[200px] overflow-auto containerScroll text-sm`}>
                <ul>
                    {
                        listaOpciones
                        .filter(e => e.text.toLowerCase().includes(textoInput.toLowerCase()))
                        .map((data,i) => 
                            <li 
                                key={i+1} 
                                onClick={() => {
                                    cambiarOpcionSeleccionada(data.value)
                                    setTextoInput('')
                                    setOpcionSeleccionada(0)
                                }} 
                                className={`${opcionSeleccionada == data.value ? 'bg-[#1967d2]' : ''} hover:bg-[#1967d2] cursor-default py-1 px-2`}
                            >
                                {data.text}
                            </li>
                        )
                    }
                </ul>
            </div>
        </div>
    );
};
